<template>
    <div class="assembleMain_content">
        <div class="assembleMain_group" v-if="segment_list.length" v-for="(item,group) in segment_list" :key="item.id" :id="'group'+group">
            <!-- 题组头部 -->
            <div class="assembleMain_group_info" v-if="assemblyData.options.struct_segmentmemo||assemblyData.options.struct_segment">
                <!-- 题组标题 -->
                <h2>
                    <i>{{getChineseNumber(group)}}.</i>
                    <i v-if="assemblyData.options.struct_segment&&editActive != group" @click="editGroupName(item,group)" :title="item.name">{{item.name}}</i>
                    <input v-show="editActive == group" type="text" ref="editGroupName" v-model.trim="item.name" @blur="editGroupName(item)" maxlength="30" />
                    <span v-if="assemblyData.options.struct_segmentmemo" v-html="getStructSegmentmemo(group)"></span>
                </h2>
                <!-- 题组操作 -->
                <div class="assembleMain_group_info_bottom">
                    <p @click="delGroup(group)"><span class="iconfont icon-shanchu"></span>删除</p>
                    <p v-if="item.questions.length" @click="setScoreShow(group)"><span class="iconfont icon-shezhifenshu"></span>批量设定得分</p>
                </div>
            </div>
            <!-- 试题 -->
            <xes-question-single 
                v-for="(test,num) in item.questions"
                move 
                :key="test.test_id||test.material_id+'m'"
                :data="test"
                :index="num"
                :serial="setNumber(group,num)"
                :group="group"
                @drag-start="dragClick"
                @drag-click="dragClick"
                :activeid="activeId"
                @drop="boxDrop"
                @set-drop-view="setDropView"
                :drop-view="dropView"
                :options="question_options"
                :mode="question_mode"
                :expand="question_expand"
                :operatingfloat="question_operatingfloat"
            >
                <template slot="topButtons" slot-scope="{data,index}">
                    <p @click="delQuestion(data,index)"><span class="iconfont icon-shanchu"></span>删除</p>
                    <p @click="setTransfer(data,index)"><span class="iconfont icon-zhuanyi"></span>转移</p>
                    <p @click="setScoreShow(index)"><span class="iconfont icon-shezhifenshu"></span>设定得分</p>
                </template>
                <template slot="floatButtons" slot-scope="{data,index}">
                    <p @click="delQuestion(data,index)"><span class="iconfont icon-shanchu"></span>删除</p>
                    <p v-if="!data.material_id" @click="setTransfer(data,index)"><span class="iconfont icon-zhuanyi"></span>转移</p>
                    <p @click="setScoreShow(index)"><span class="iconfont icon-shezhifenshu"></span>设定得分</p>
                </template>
            </xes-question-single>
        </div>
    </div>
</template>
<script>
import $store from '../store'
import utils from './utils'
import leftStyle from './leftStyle'
export default {
    props: ['question_options','question_mode','question_expand','question_operatingfloat','title_edit'],
    data () {
        return {
            editActive:null,//试题修改
            dropView:false
        }
    },
    computed: {
        assemblyData(){
            return $store.state.assemblyData
        },
        segment_list(){
            return $store.state.segment_list
        },
        currentNode(){
            return $store.state.currentNode
        },
        spacingViewShow:{
            get(){
                return $store.state.spacingViewShow
            },
            set(val){
                $store.commit('SETASSEMBLYSTATE',{name:'spacingViewShow',value:val})
            }
        },
        activeId(){
            let active = $store.getters.activeTest
            if(active.question_list){
                return {material_id:active.material_id}
            }
            return {id:active.id}
        }
    },
    methods: {
        setScoreShow(index){//设置得分
            let data = Array.isArray(index)?index:[index]
            $store.commit('SETSELECTEDNODE',data)
            $store.commit('SETSCORESHOW')
        },
        delGroup(index){//删除题组
            let data = [index]
            $store.commit('SETSELECTEDNODE',data)
            this.$msgBox.delDialog('确认删除该大题么',()=>{
                $store.commit('DELASSEMBLEQUESTION',()=>this.$emit('delEmpty'))
            })
        },
        getStructSegmentmemo(index){//题组题数、分数计算
            let big = 0
            let small = 0
            let score = 0
            let group = this.assemblyData.segment_list[index].questions
            big = group.length
            group.forEach(one => {
                if(one.material_id){
                    small += one.question_list.length
                    one.question_list.forEach(two=>{
                        // score += Number(two.test_score)
                        score = utils.formatNum(score+Number(two.test_score),2)
                    })
                }else{
                    small ++
                    score = utils.formatNum(score+Number(one.test_score),2)
                    // score += Number(one.test_score)
                }
            });
            if(big == small){
                return `（共${big}题，共${score}分）`
            }else{
                return `（共${big}题，${small}小题；共${score}分）`
            }
        },
        editGroupName(item,index){//编辑题组名称
            if(!this.title_edit.grouptitle) return
            if(typeof(index) == 'number'){
                this.editActive = index
                this.$nextTick(()=>{
                    this.$refs.editGroupName[index].focus()
                })
            }else{
                if(!item.name){
                    item.name = this.assemblyData.segment_list[this.editActive].name
                }
                $store.commit('RENEWASSEMBLESTORE',{name:['segment_list',this.editActive,'name'],value:this.segment_list[this.editActive].name})
                this.editActive = null
            }
        },
        getChineseNumber(index){//对应中文数字
            return utils.getChineseNumber(index+1)
        },
        delQuestion(){//删除
            this.$msgBox.delDialog('确认删除该试题么',()=>{
                if(this.currentNode.length == 3&&this.assemblyData.segment_list[this.currentNode[0]].questions[this.currentNode[1]].question_list.length == 1){
                    $store.commit('SETSELECTEDNODE',[this.currentNode[0],this.currentNode[1]])
                }
                $store.commit('DELASSEMBLEQUESTION',()=>this.$emit('delEmpty'))
            })
        },
        setTransfer(){
            $store.commit('SETQUESTIONTRANSFERSHOW')
        },
        dragClick(data,index){
            $store.commit('SETSELECTEDNODE',index)
        },
        setDropView(state){
            this.dropView = state
        },
        boxDrop(data,index){
            $store.commit('MOVEASSEMBLYNODE',index)
        },
        setNumber(index,num){
            let sum = 0
            this.assemblyData.segment_list.forEach((el,i)=>{
                if(i>=index){
                    return
                }
                sum += el.questions.length
            })
            sum=sum+num
            return sum
        }
    },
    components:{
        leftStyle
    }
}
</script>




// WEBPACK FOOTER //
// packages/question-assembly/src/mainGroup.vue